import React, { useState } from "react"
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Checkbox,
  Button,
  Typography,
  Box,
} from "@mui/material"
import dayjs from "dayjs";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useAuth } from "../../Auth/AuthProvider";
import { useNavigate, useParams } from "react-router-dom";
import { can } from "../../Conections/LogConections";
import { GetEstudentsDataAPI, SetStudentList } from "../../Conections/AcademicConection";
import { DateField, TimeField } from "@mui/x-date-pickers";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

/*const students = [
  { id: "1", code: "001", firstName: "Juan", lastName: "Pérez" },
  { id: "2", code: "002", firstName: "María", lastName: "González" },
  { id: "3", code: "003", firstName: "Carlos", lastName: "Rodríguez" },
  // Agrega más estudiantes aquí
]*/

export default function StudentList() {

  const { getToken, getCompany } = useAuth();
  const goTo = useNavigate();
  const { group } = useParams();

  const [searchTerm, setSearchTerm] = useState("")
  const [students, setStudents] = useState([])
  const [selectedStudents, setSelectedStudents] = useState([])
  const [selectedDate, setSelectedDate] = useState(dayjs()); // Estado para la fecha
  const [selectedTime, setSelectedTime] = useState(dayjs()); // Estado para la hora

  React.useEffect(() => {
    async function reloaduser() {
      if (getToken()) {
        const permisionCan = await can(getToken(), getCompany(), "/academic/studentlist/:group");
        if (permisionCan === 1) {
          let Estudents = await GetEstudentsDataAPI(getToken(), getCompany(), group);

          const listEstudents = Estudents.map(Estudent => ({
            id: Estudent.id,
            code: Estudent.code,
            firstName: Estudent.firstname,
            lastName: Estudent.lastname
          }));
          setStudents(listEstudents);
          console.log(listEstudents);
        }
        else {
          goTo("/dashboard");
        }
      }
      else {
        goTo(`/login`);
      }
    };
    reloaduser();
  }, [group, getCompany, getToken, goTo]);

  const filteredStudents = students.filter((student) =>
    Object.values(student).some((value) => String(value).toLowerCase().includes(searchTerm.toLowerCase())),
  )

  const handleCheckboxChange = (studentId) => {
    setSelectedStudents((prev) =>
      prev.includes(studentId) ? prev.filter((id) => id !== studentId) : [...prev, studentId],
    )
  }

  const validateForm = () => {
    /*const newErrors = {};
    if (!grupo.nombre.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }
    if (!grupo.descripcion.trim()) {
      newErrors.descripcion = 'La descripción es requerida';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;*/
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    console.log("Estudiantes seleccionados:", selectedStudents);
    console.log("Fecha: ", selectedDate["$y"], (selectedDate["$M"] + 1), selectedDate["$D"]);
    console.log("Hora: ", selectedTime["$H"], selectedTime["$m"])
    
    if (validateForm()) {

      const datos = await SetStudentList(
        getToken(),
        getCompany(),
        group,
        selectedStudents,
        selectedDate["$y"], 
        (selectedDate["$M"] + 1), 
        selectedDate["$D"],
        selectedTime["$H"], 
        selectedTime["$m"]
      );
      console.log(datos);
      goTo(`/academic/studentlistshow/${group}`);
    }
    
    // Aquí puedes enviar los datos a tu backend
  }

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom>
        Lista de Estudiantes
      </Typography>
      <Card style={{ marginBottom: "20px" }}>
        <CardContent>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateField', 'TimeField']}>
              <DateField
                label="Basic date field"
                defaultValue={dayjs()}
                onChange={(newValue) => setSelectedDate(newValue)}
              />
              <TimeField
                label="Uncontrolled field"
                defaultValue={dayjs()}
                onChange={(newValue) => setSelectedTime(newValue)}
              />
            </DemoContainer>
          </LocalizationProvider>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <TextField
            fullWidth
            label="Buscar estudiantes"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ marginBottom: "20px" }}
          />
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Código</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Apellido</TableCell>
                  <TableCell>Seleccionar</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredStudents.map((student) => (
                  <TableRow key={student.id}>
                    <TableCell>{student.code}</TableCell>
                    <TableCell>{student.firstName}</TableCell>
                    <TableCell>{student.lastName}</TableCell>
                    <TableCell>
                      <Checkbox
                        checked={selectedStudents.includes(student.id)}
                        onChange={() => handleCheckboxChange(student.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button variant="contained" color="primary" onClick={handleSubmit} style={{ marginTop: "20px" }}>
            Enviar selección
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}

